import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import Fade from '@mui/material/Fade'
import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { useTranslation } from 'react-i18next'

type VendorContactInfoCardMenuProps = {
  onEdit: () => void
  onDelete: () => void
  isDeleteDisabled?: boolean
}

const VendorContactInfoCardMenu: React.FC<VendorContactInfoCardMenuProps> = ({
  onEdit,
  onDelete,
  isDeleteDisabled = false
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { t } = useTranslation()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEditClick = () => {
    setAnchorEl(null)
    onEdit()
  }

  const handleDeleteClick = () => {
    setAnchorEl(null)
    onDelete()
  }

  return (
    <>
      <IconButton aria-label="settings" edge="end" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} TransitionComponent={Fade}>
        <MenuItem onClick={handleEditClick}>{t('edit')}</MenuItem>
        <MenuItem disabled={isDeleteDisabled} onClick={handleDeleteClick}>
          {t('delete')}
        </MenuItem>
      </Menu>
    </>
  )
}

export default VendorContactInfoCardMenu
